<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateApplication)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Application - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label">
              Status
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <ValidationProvider
                name="application_status"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Status</label>
                  <md-select
                    v-model="next_application_status"
                    name="status"
                    @md-selected="onChange"
                  >
                    <md-option value="">Select Status</md-option>
                    <md-option
                      v-for="c in all_application_status[application_status]"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="next_application_status === 50 && application_status !== 60"
            >
              Offer Letter
            </label>
            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="next_application_status === 60"
            >
              Payment receipt
            </label>
            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="next_application_status === 70"
            >
              Acceptance letter
            </label>
            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="next_application_status === 100"
            >
              Visa rejected file
            </label>
            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="next_application_status === 120"
            >
              Student certificate
            </label>
            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="next_application_status === 130"
            >
              Refund Request file
            </label>

            <div class="md-layout-item md-size-75" v-if="showFileInput()">
              <ValidationProvider
                name="file"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-file
                    v-model="custom_file"
                    name="file"
                    @change="onFileChange"
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="showMessageInput()"
            >
              Message
            </label>
            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="
                next_application_status === 110 ||
                  next_application_status === 120
              "
            >
              Student Number
            </label>

            <div
              class="md-layout-item"
              v-if="
                showMessageInput() ||
                  next_application_status === 110 ||
                  next_application_status === 120
              "
            >
              <ValidationProvider
                name="message"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-input v-model="message" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                type="submit"
                class="md-raised md-success mt-4"
                :disabled="
                  application_status === 120 ||
                    application_status === 170 ||
                    application_status === 180 ||
                    application_status === 190 ||
                    application_status === 10 ||
                    application_status === 140 ||
                    disabled
                "
                >Update Application
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      applicationID: null,
      custom_file: null,
      disabled: false,

      application_status: null,
      next_application_status: null,
      file: null,
      message: "",
      all_application_status: {
        10: [],
        20: [
          { id: 150, name: "Missing documents" },
          { id: 160, name: "Declined/Rejected" },
          { id: 50, name: "Offer sent" }
        ],
        150: [{ id: 20, name: "On process" }],
        160: [{ id: 20, name: "On process" }],
        50: [{ id: 60, name: "Waiting Final acceptance" }],
        60: [
          { id: 70, name: "Acceptance letter sent" },
          { id: 50, name: "Offer sent" }
        ],
        70: [
          { id: 80, name: "Visa applied" },
          { id: 110, name: "Enrolled (Waiting student certificate)" },
          { id: 120, name: "Enrolled" }
        ],
        80: [
          { id: 90, name: "Visa received" },
          { id: 100, name: "Visa rejected" },
          { id: 110, name: "Enrolled (Waiting student certificate)" },
          { id: 120, name: "Enrolled" }
        ],
        90: [
          { id: 110, name: "Enrolled (Waiting student certificate)" },
          { id: 120, name: "Enrolled" }
        ],
        100: [{ id: 130, name: "Refund requested" }],
        110: [{ id: 120, name: "Enrolled" }],
        120: [],
        130: [{ id: 140, name: "Refunded" }],
        140: [],
        170: [],
        180: [],
        190: []
      }
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    onChange() {
      this.file = null;
      this.custom_file = null;
      this.message = null;
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];
      this.custom_file = files[0];
    },
    showFileInput() {
      if (
        this.next_application_status === 50 &&
        this.application_status === 60
      ) {
        return false;
      }
      return (
        this.next_application_status === 50 ||
        this.next_application_status === 60 ||
        this.next_application_status === 70 ||
        this.next_application_status === 100 ||
        this.next_application_status === 120 ||
        this.next_application_status === 130
      );
    },
    showMessageInput() {
      if (
        this.next_application_status === 50 &&
        this.application_status === 60
      ) {
        return true;
      }
      return (
        this.next_application_status === 150 ||
        this.next_application_status === 160
      );
    },
    updateApplication() {
      let data = {
        status: this.next_application_status,
        file: this.file,
        message: this.message
      };
      for (const field in data) {
        if (
          data[field] === null ||
          data[field] === undefined ||
          data[field] === ""
        ) {
          delete data[field];
        }
      }
      this.disabled = true;
      this.$store
        .nextStatus(data, this.applicationID)
        .then(response => {
          this.disabled = false;
          this.$notify({
            message: "Application updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
          this.application_status = this.next_application_status;
          this.next_application_status = null;
          this.file = null;
          this.message = null;
          this.$emit("refresh", this.application_status);
        })
        .catch(error => {
          this.disabled = false;
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.applicationID = this.$route.params.application_id;
  }
};
</script>
